import { render, staticRenderFns } from "./FareOrder.vue?vue&type=template&id=da8b8abc&scoped=true&"
import script from "./FareOrder.vue?vue&type=script&lang=js&"
export * from "./FareOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8b8abc",
  null
  
)

export default component.exports